module.exports = __webpack_public_path__ + "static/media/spec-code.45838a6c.png";